<div class="usa-map-card">

  <!-- =====================================================
       HEADER
  ====================================================== -->
  <div class="map-header">

    <div class="map-title-section">

      <div class="map-icon">
        <i class="fa-solid fa-map-location-dot"></i>
      </div>

      <div class="map-heading">
        <h3>Select States</h3>

        <p>
          Choose the states you want to include in your policy.
        </p>
      </div>

    </div>

    <div class="map-actions">

      <!-- <button type="button" class="select-all-btn" (click)="selectAllStates()">
        <i class="fa-solid fa-check-double"></i>
        <span>Select All States</span>
      </button> -->

    </div>

  </div>


  <!-- =====================================================
       MAIN CONTENT
  ====================================================== -->
  <div class="map-content">


    <div class="map-panel">
      <!-- <div class="map-legend">

        <div class="legend-item">
          <span class="legend-color paid"></span>
          <span>Paid State</span>
        </div>

        <div class="legend-item">
          <span class="legend-color available"></span>
          <span>Document Available</span>
        </div>

        <div class="legend-item">
          <span class="legend-color unavailable"></span>
          <span>No Document</span>
        </div>

        <div class="legend-item">
          <span class="legend-color selected"></span>
          <span>Selected</span>
        </div>

      </div> -->
      <!-- MAP -->
      <div class="map-wrapper">


        <div class="map-background"></div>

        <object #usaSvg id="usaSvg" class="usa-map" data="assets/maps/usa.svg" type="image/svg+xml">
        </object>

      </div>

    </div>


    <!-- ===================================================
         RIGHT SIDE : STATE INFORMATION
    ==================================================== -->
    <div class="state-panel">

      @if (hoverState) {

      <div class="state-details">

        <!-- State Header -->
        <div class="state-details-header">

          <div class="state-location-icon">
            <i class="fa-solid fa-location-dot"></i>
          </div>

          <div>

            <span class="state-label">
              Selected State
            </span>

            <h4>
              {{ hoverState }}
            </h4>

          </div>

        </div>


        <!-- Divider -->
        <div class="state-divider"></div>


        <div class="documents-section">

          @if (stateDocuments?.length) {

          <!-- =====================================================
         DOCUMENT LIST
    ====================================================== -->
          <div class="state-document-list">

            @for (
            item of stateDocuments;
            track item.id ?? $index
            ) {

            <div class="state-document-item">

              <!-- File Icon -->
              <div class="document-file-icon">
                <i class="fa-regular fa-file-lines"></i>
              </div>

              <!-- Document Information -->
              <div class="document-content">

                <div class="document-title">
                  {{ item.message }}
                </div>

                <!-- <div class="document-meta">
                  <span>
                    <i class="fa-regular fa-file-lines"></i>
                    Document
                  </span>
                </div> -->

              </div>

              <!-- View Action -->
              <button type="button" class="document-view-btn" title="View document" aria-label="View document"
                (click)="viewDocument(item)">
                <i class="fa-regular fa-eye"></i>
              </button>

            </div>

            }

          </div>


          <!-- =====================================================
         CONTINUE FOOTER
    ====================================================== -->
          <div class="documents-footer">

            <button type="button" class="btn continue-btn" [disabled]="!canContinue || isDocumentsLoading"
              (click)="continueToAskQuestion()">
              @if (isDocumentsLoading) {

              <i class="fa-solid fa-spinner fa-spin me-2"></i>
              Loading...

              } @else {

              Continue
              <i class="fa-solid fa-arrow-right ms-2"></i>

              }
            </button>

          </div>

          } @else {

          <!-- =====================================================
         EMPTY DOCUMENT STATE
    ====================================================== -->
          <div class="no-state-documents">

            <div class="empty-document-icon">
              <i class="fa-regular fa-folder-open"></i>
            </div>

            <strong>
              No documents available
            </strong>

            <span>
              There are currently no documents
              available for {{ hoverState }}.
            </span>

          </div>

          }

        </div>


        <!-- =========================================================
          DOCUMENT VIEW MODAL
        ========================================================= -->

        @if (selectedDocument) {

        <div class="document-modal-backdrop" (click)="closeDocument()">

          <div class="document-modal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

            <!-- Header -->
            <div class="document-modal-header">

              <div class="document-modal-title">

                <div class="modal-file-icon">
                  <i class="fa-regular fa-file-lines"></i>
                </div>

                <div>
                  <h3>
                    {{ selectedDocument.message }}
                  </h3>
                </div>

              </div>

              <button type="button" class="modal-close-btn" aria-label="Close document" title="Close"
                (click)="closeDocumentModal()">
                <i class="fa-solid fa-xmark"></i>
              </button>

            </div>


            <!-- Document Body -->
            <div class="document-modal-body">

              <section class="viewer-section">
                <!-- Loading -->
                @if (documentLoading) {
                <div class="loader-container">
                  <div class="loader-icon">
                    <i class="pi pi-spin pi-spinner"></i>
                  </div>
                  <h4>Loading document</h4>
                  <p>Please wait while the document is being loaded...</p>
                </div>
                }

                <!-- Video / Audio -->
                @if ( isSelectFileType === 'video' || isSelectFileType === 'audio') {
                <div class="media-viewer">
                  <vg-player>
                    <vg-overlay-play></vg-overlay-play>
                    <vg-buffering></vg-buffering>
                    <vg-scrub-bar>
                      <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                      <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                      <div id="video-controls">
                        <div id="seek-bar-container">
                          <div id="seek-bar">
                            <div id="current-time">
                              @for (percent of markerSeekBar; track percent) {
                              <div class="bubles" [ngStyle]="{ left: percent }"></div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </vg-scrub-bar>
                    <vg-controls [vgAutohide]="true" [vgAutohideTime]="2">
                      <vg-play-pause></vg-play-pause>
                      <vg-time-display vgProperty="current" vgFormat="mm:ss">
                      </vg-time-display>
                      <span class="time-divider">/</span>
                      <vg-time-display vgProperty="total" vgFormat="mm:ss">
                      </vg-time-display>
                      <vg-scrub-bar class="control-spacer" style="pointer-events: none">
                      </vg-scrub-bar>
                      <vg-mute></vg-mute>
                      <vg-volume></vg-volume>
                      <vg-fullscreen></vg-fullscreen>
                    </vg-controls>
                    <video #media [vgMedia]="media" id="singleVideo" crossorigin
                      (timeupdate)="getVideoPlayingOnTime($event.target.currentTime)">
                      <source [src]="selectedReadFile" type="video/mp4" />
                    </video>
                  </vg-player>
                </div>
                } @else { @if (!documentLoading) {
                <div class="document-preview">
                  <ngx-doc-viewer [url]="selectedReadFile" viewer="google" [googleCheckContentLoaded]="true"
                    [googleCheckInterval]="3000" [googleMaxChecks]="5" style="width: 100%; height: 100%"
                    (loaded)="contentLoaded()">
                  </ngx-doc-viewer>
                </div>
                } }

                <!-- Document Viewer -->
              </section>

            </div>


            <!-- Footer -->
            <div class="document-modal-footer">

              <div class="footer-info">
                <i class="fa-solid fa-circle-info"></i>

                <span>
                  Viewing document for {{ hoverState }}
                </span>
              </div>

              <button type="button" class="modal-secondary-btn" (click)="closeDocumentModal()">
                Close
              </button>

            </div>

          </div>

        </div>

        }

      </div>

      } @else {

      <!-- Empty State -->
      <div class="state-empty">

        <div class="empty-map-icon">
          <i class="fa-solid fa-map-location-dot"></i>
        </div>

        <h4>
          Select a State
        </h4>

        <p>
          Choose a state from the map to view
          its available documents.
        </p>

      </div>

      }

    </div>

  </div>

</div>
